import * as config from "./../config/config";
import api from "./interceptor";

export async function create_devis(data) {
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_DEVIS, {
      date_depart: data["date_depart"],
      date_arrive: data["date_arrive"],
      region_depart: data["region_depart"],
      region_arrive: data["region_arrive"],
      distance: data["distance"],
      poids: data["poids"],
      description: data["description"],
      perdiem_chauffeur: data["perdiem_chauffeur"],
      perdiem_chauffeur_multi: data["multi_perdiem_chauffeur"],
      perdiem_aide: data["perdiem_aide"],
      perdiem_aide_multi: data["multi_perdiem_aide"],
      credit: data["credit"],
      credit_multi: data["mult_credit"],
      parking: data["parking"],
      parking_multi: data["mult_parking"],
      contravention: data["contravention"],
      contravention_multi: data["mult_contravention"],
      divers: data["divers"],
      divers_multi: data["mult_divers"],
      chargement: data["chargement"],
      chargement_multi: data["chargement_multi"],
      dechargement: data["dechargement"],
      dechargement_multi: data["dechargement_multi"],
      arrimage: data["arrimage"],
      arrimage_multi: data["arrimage_multi"],
      coefficient_charge: data["coefficient_charge"],
      coefficient_vide: data["coefficient_vide"],
      status_aller: data["status_aller"],
      status_retour: data["status_retour"],
      prix_go: data["prix_gasoil"],
      cotation: data["cotation"],
      total_carburant: data["carburant"],
      total_go: data["total_gasoil"],
      total_brut: data["total_brute"],
      total_benefice: data["total_benefice"],
      total_depense: data["total_frais"],
      carburant_aller: data["carburant_aller"],
      carburant_retour: data["carburant_retour"],
      tva: data["tva"],
      acompte: data["acompte"],
      paiement: data["paiement"],
      client_id: data["client_id"],
      user_create_id: localStorage.getItem("user_id"),
      cotation_type: data['cotation_type'],
      coefficient_distance: data['coefficient_distance'],
      type_devis: data['type_devis'],
      limite_paiement: data['limite_paiement'],
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function create_devis_bennes(data) {
  data['user_create_id'] = localStorage.getItem('user_id')
  const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_DEVIS_BENNES, data)
  return response.data;
}

export async function getall_devis({ start, end } = {}) {
  try {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;

    const response = await api.get(config.REACT_APP_ENDPOINT_LISTE_DEVIS, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function get_devis(devis_id) {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_GET_DEVIS + devis_id);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function toggle_devis(devis_id, statut_devis) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_TOGGLE_DEVIS + devis_id,
      {
        statut_devis: statut_devis,
        user_id: localStorage.getItem('user_id')
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function downloadDevis(devis_id) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_DOWNLOAD_DEVIS + devis_id,
      {}, // <- pas de body à envoyer ici
      { responseType: "blob" } // ✅ c’est ici qu’on met le responseType
    );

    // 🔽 Créer un blob PDF à partir des données reçues
    const blob = new Blob([response.data], { type: "application/pdf" });

    // Récupérer le nom du fichier depuis les headers si dispo
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "devis.pdf";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) fileName = match[1];
    }

    // 🔽 Créer et déclencher le téléchargement
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Nettoyage
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("❌ Erreur lors du téléchargement du devis :", error);
    throw error;
  }
}

export async function export_devis(params) {
  try {
    const response = await api.get(
      `${config.REACT_APP_ENDPOINT_EXPORT_DEVIS}?${params.toString()}`,
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `devis_export.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    return 1
  } catch (error) {
    throw error;
    return 0
  }
}


export async function merge_devis(listid, optionFusion) {
   try {
    const response = await api.post(config.REACT_APP_ENDPOINT_MERGE_DEVIS, {
      "listId" : JSON.stringify(listid),
      "tva": optionFusion.tva,
      "acompte": optionFusion.acompte,
      "paiement": optionFusion.paiement
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}


export async function duplicate_devis(devis_id) {
   try {
    const response = await api.post(config.REACT_APP_ENDPOINT_DUPLICATE_DEVIS + devis_id);
    return response.data;
  } catch (error) {
    throw error;
  }
}


export async function update_devis(data) {
   try {
    const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_DEVIS + data['id'], {
      data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}